<template>
  <div class="plv-iar-product__total pws-product-aside-bg-color pws-body-font-color2 pws-iar-product-list-total">
    <IconProductTotal
      class="pws-iar-icon-product-list-icon"
      :size="12"
      color="#fff" />
    {{ iarTrans('product.quantity') }}：<span class="pws-iar-product-list-total-hightlight">{{ total }}</span>
  </div>
</template>

<script>
import basicMixin from '../../../assets/mixins/basic';
import IconProductTotal from '../../../icon-components/icons/icon-product-total';
export default {
  mixins: [basicMixin],
  components: {
    IconProductTotal,
  },

  inject: ['productVm'],

  props: {
    total: {
      type: Number,
      default: 0,
    }
  },
};
</script>

<style lang="scss">
.plv-iar-product__total {
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  padding-bottom: 14px;

  span {
    color: #F15D5D;
    margin-left: 3px;
    margin-right: 3px;
  }
}
.plv-iar-product-label-list + .plv-iar-product__total {
  padding-top: 4px;
}
</style>
